import { globalContext } from 'context/global';
import { useContext } from 'react';
import {
  Wrapper,
  HeaderContent,
  Title,
  Subtitle,
  ChildrenContent,
} from './styles';

interface IHeader {
  children?: React.ReactNode;
  franchisee?: boolean;
}

export const Header = ({ children, franchisee = true }: IHeader) => {
  const { containerContext } = useContext(globalContext);

  return (
    <Wrapper>
      <HeaderContent>
        <Title>
          Bem-vindo(a),{' '}
          <span className="user"> {containerContext.user.name}!</span>
        </Title>
        {franchisee && (
          <Subtitle>
            Agora ficou fácil e mais rápido fazer avisos de sinistro, além de
            poder acompanhar o processo do início ao fim em cada etapa!
          </Subtitle>
        )}
      </HeaderContent>
      {children && <ChildrenContent>{children}</ChildrenContent>}
    </Wrapper>
  );
};
